var dfs = require('./dfs');
module.exports = postorder;
function postorder(g, vs) {
  return dfs(g, vs, 'post');
}